@if (isMedia || title) {
  <div class="button__media-info">
    @if (title) {
      <h4 class="button__title">{{ title }}</h4>
    }

    @if (isMedia) {
      <p>{{ extension }} - {{ fileSize }}</p>
    }
  </div>
}

@if (!isModal && !isInline) {
  @if (isLink) {
    @if (!checkLinkAvailability(href)) {
      <dotcom-frontend-link
        [adobeData]="adobeData"
        [isLgButton]="true"
        [lgButtonIconPosition]="iconAlignment"
        [lgButtonVariant]="getButtonClass(buttonStyle)"
        [ngClass]="{ 'primary-green': getGreenButton(buttonStyle) }"
        [target]="target"
        [url]="href"
        [tabindex]="tabIndex !== 0 ? tabIndex : null"
      >
        <ng-container [ngTemplateOutlet]="iconText" />
      </dotcom-frontend-link>
    }
  } @else {
    <button
      (click)="
        interactionClickEvent(adobeData, 'Box Block', adobeData.interactionLink)
      "
      [ngClass]="{ 'primary-green': getGreenButton(buttonStyle) }"
      [variant]="getButtonClass(buttonStyle)"
      lg-button
    >
      <ng-container [ngTemplateOutlet]="iconText" />
    </button>
  }
} @else {
  @if (modalComponent) {
    <dotcom-frontend-loader [componentData]="modalComponent" />
  } @else {
    <button
      (click)="
        loadInlineData(inLineContainerParentId, contentLoadedId);
        interactionClickEvent(
          adobeData,
          'Inline Block',
          'Open inline block action'
        )
      "
      [ngClass]="{ 'primary-green': getGreenButton(buttonStyle) }"
      [variant]="getButtonClass(buttonStyle)"
      lg-button
    >
      <ng-container [ngTemplateOutlet]="iconText" />
    </button>
  }
}

<ng-template #iconText>
  @if (iconAlignment !== "left") {
    <span class="btn-text">{{ text }}</span>
    @if (icon) {
      <lg-icon [name]="icon['selector']" />
    }
  } @else {
    @if (icon) {
      <lg-icon [name]="icon['selector']" />
    }
    <span class="btn-text">{{ text }}</span>
  }
</ng-template>

@if (contentLoadedId && isInline) {
  <div #inLineContainer class="in-line-container">
    @if (isLoading) {
      <lg-spinner></lg-spinner>
    }
    <div
      class="in-line-content"
      [ngClass]="{ 'content-loaded': contentLoaded }"
    >
      <div class="content-visibility">
        @if (inlineComponent) {
          <dotcom-frontend-loader
            [componentData]="inlineComponent"
            [parentBlock]="'_inLineBlock'"
          />
        }
      </div>
    </div>
  </div>
}
